module.exports = __webpack_public_path__ + "static/media/20.0050982d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/20.svg
// module id = 393
// module chunks = 14